import React, { useState } from 'react'
import Header from "../template/Header";
import Menu from "../template/Menu";
import Footer from "../template/Footer";
import { Button, Col, Row } from "react-bootstrap";
import Loading from "../components/loading/Loading";
import Text from '../components/inputTxt/Text';
import UploadIMG from "../components/uploads/UploadIMG";
import UploadFilePDF from "../components/uploads/UploadFilePDF";
import { useNavigate } from 'react-router-dom';
import { createAndUpdateAboutus, getDataAboutUs } from '../api/admin_cms'
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../components/useDynamic/Button_DynamicStyle";
import { useEffect } from 'react';
import {
    alertValidateData,
    alertOverLimit,
    alertConfirmSave,
    alertSaved,
    alertCancel,
} from "../components/alertValid/AlertValid.js"
import CustomCKEditor from '../components/ckEditor/CustomCKEditor.js';

function AboutUs() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );

    const [isLoading, setLoading] = useState(false);

    const [editId, setEditId] = useState(null);
    const [txtEnCompany, setTxtEnCompany] = useState('');
    const [txtThCompany, setTxtThCompany] = useState('');
    const [txtEnBackground, setTxtEnBackground] = useState('');
    const [txtThBackground, setTxtThBackground] = useState('');
    const [txtEnVisionMission, setTxtEnVisionMission] = useState('');
    const [txtThVisionMission, setTxtThVisionMission] = useState('');
    const [images1, setImages1] = useState([]);
    const [imagesFromApi1, setImagesFromApi1] = useState([]);
    const [images2, setImages2] = useState([]);
    const [imagesFromApi2, setImagesFromApi2] = useState([]);
    const [images3, setImages3] = useState([]);
    const [imagesFromApi3, setImagesFromApi3] = useState([]);
    const [dataDetail, setDataDetail] = useState([
        {
            eng: { title: 'testTitleEn1', des: 'testDesEn1' },
            tha: { title: 'testTitleTh1', des: 'testDesTh1' }
        },
        {
            eng: { title: 'testTitleEn2', des: 'testDesEn2' },
            tha: { title: 'testTitleTh2', des: 'testDesTh2' }
        },
    ]);

    const handleChangeInpEnTitle = async (index, newValue) => {
        // Trim newValue to 50 characters
        const trimmedValue = newValue.substring(0, 50);
        const newDataDetail = [...dataDetail]; // Create a copy of the dataDetail array
        newDataDetail[index].eng.title = trimmedValue; // Update the Thai title of the specified index
        setDataDetail(newDataDetail);
        if (newValue?.length > 50) {
            const result = await alertOverLimit();
                if (result.isConfirmed) {
                    setDataDetail(newDataDetail); // Update the state with the modified array
                }
                else {
                    setDataDetail(newDataDetail);
                }
        } else {
            setDataDetail(newDataDetail); // Update the state with the modified array
        }
    };

    const handleChangeInpThTitle = async (index, newValue) => {
        // Trim newValue to 50 characters
        const trimmedValue = newValue.substring(0, 50);
        const newDataDetail = [...dataDetail]; // Create a copy of the dataDetail array
        newDataDetail[index].tha.title = trimmedValue; // Update the Thai title of the specified index
        setDataDetail(newDataDetail);
        if (newValue?.length > 50) {
            const result = await alertOverLimit();
                if (result.isConfirmed) {
                    setDataDetail(newDataDetail); // Update the state with the modified array
                }
                else {
                    setDataDetail(newDataDetail);
                }
        } else {
            setDataDetail(newDataDetail); // Update the state with the modified array
        }
    };

    const updateDescription = (index, language, newValue) => {
        setDataDetail((prevDataDetail) =>
            prevDataDetail.map((item, i) =>
            i === index
                ? {
                    ...item,
                    [language]: { ...item[language], des: newValue } // ใช้ [language] เพื่อเลือกภาษา
                }
                : item
            )
        );
    };

    const handleSelectedImages1 = (images) => {
        setImages1(images);
    };
    const handleSelectedRemoveImg1 = (data) => {
        // setDataStClear(data);
        setImages1(data);
    };

    const handleSelectedImages2 = (images) => {
        setImages2(images);
    };
    const handleSelectedRemoveImg2 = (data) => {
        // setDataStClear(data);
        setImages2(data);
    };

    const handleSelectedImages3 = (images) => {
        setImages3(images);
    };

    const handleSelectedRemoveImg3 = (data) => {
        // setDataStClear(data);
        setImages3(data);
    };

    const navigate = useNavigate();
    const navigateToBack = (page) => {
        navigate(page);
    };

    const alertValidate = async () => {
        const result = await alertValidateData();
            if (result.isConfirmed) {
                return;
            } else {
                return;
            }
    }

    const handleSaveBtn = async () => {
        if (editId) {
            const formatedBodyToServer = {
                company_profile_en: txtEnCompany,
                company_profile_th: txtThCompany,
                company_vission_en: txtEnVisionMission,
                company_vission_th: txtThVisionMission,
                company_background_en: txtEnBackground,
                company_background_th: txtThBackground,
                detail_list: dataDetail?.map((item) => {
                    return {
                        title_en: item.eng.title,
                        title_th: item.tha.title,
                        description_en: item.eng.des,
                        description_th: item.tha.des,
                        file: null
                    }
                }),
                image_vission: images2 ?? null,
                image_company_background: images1 ?? null,
                privacy_file: images3 ?? null,
            }
            if (
                !formatedBodyToServer.company_profile_en ||
                !formatedBodyToServer.company_profile_th ||
                !formatedBodyToServer.company_vission_en ||
                !formatedBodyToServer.company_vission_th ||
                !formatedBodyToServer.company_background_en ||
                !formatedBodyToServer.company_background_th ||
                formatedBodyToServer.detail_list.some(x=> !x.title_en) ||
                formatedBodyToServer.detail_list.some(x=> !x.title_th) ||
                formatedBodyToServer.detail_list.some(x=> !x.description_en) ||
                formatedBodyToServer.detail_list.some(x=> !x.description_th) ||
                !formatedBodyToServer.image_vission.length > 0 ||
                !formatedBodyToServer.image_company_background.length > 0 ||
                !formatedBodyToServer.privacy_file.length > 0
            ) {
              await alertValidate();
            } else {
                const result = await alertConfirmSave();
                    if (result.isConfirmed) {
                      (async () => {
                        await setLoading(true);
                        const response = await createAndUpdateAboutus(formatedBodyToServer);
                        setLoading(false)
                          if (response.status == "success") {
                            const result = await alertSaved();
                              if (result.isConfirmed) {
                                window.location.reload();
                              }
                          }
                      })();
                    }
            }
        } else {
            const formatedBodyToServer = {
                company_profile_en: txtEnCompany,
                company_profile_th: txtThCompany,
                company_vission_en: txtEnVisionMission,
                company_vission_th: txtThVisionMission,
                company_background_en: txtEnBackground,
                company_background_th: txtThBackground,
                detail_list: dataDetail?.map((item) => {
                    return {
                        title_en: item.eng.title,
                        title_th: item.tha.title,
                        description_en: item.eng.des,
                        description_th: item.tha.des,
                        file: null
                    }
                }),
                image_vission: images2 ?? null,
                image_company_background: images1 ?? null,
                privacy_file: images3 ?? null,
            }
            if (
                !formatedBodyToServer.company_profile_en ||
                !formatedBodyToServer.company_profile_th ||
                !formatedBodyToServer.company_vission_en ||
                !formatedBodyToServer.company_vission_th ||
                !formatedBodyToServer.company_background_en ||
                !formatedBodyToServer.company_background_th ||
                formatedBodyToServer.detail_list.some(x=> !x.title_en) ||
                formatedBodyToServer.detail_list.some(x=> !x.title_th) ||
                formatedBodyToServer.detail_list.some(x=> !x.description_en) ||
                formatedBodyToServer.detail_list.some(x=> !x.description_th) ||
                !formatedBodyToServer.image_vission.length > 0 ||
                !formatedBodyToServer.image_company_background.length > 0 ||
                !formatedBodyToServer.privacy_file.length > 0
            ) {
              await alertValidate("กรุณากรอกข้อมูลให้ครบถ้วน");
            } else {
                const result = await alertConfirmSave();
                    if (result.isConfirmed) {
                      (async () => {
                        await setLoading(true);
                        const response = await createAndUpdateAboutus(formatedBodyToServer);
                        setLoading(false)
                          if (response.status == "success") {
                            const result = await alertSaved();
                              if (result.isConfirmed) {
                                window.location.reload();
                              }
                          }
                      })();
                    }
            }
        }
    };

    const handleClickCancel = async () => {
        const res = await alertCancel();
                if (res.isConfirmed) {
                    navigateToBack("/infoAboutUs");
                }
                else { }
    };

    // Function to add an object to dataDetail array
    const addObjectToArray = () => {
        const newDataDetail = [...dataDetail, {
            eng: { title: '', des: '' },
            tha: { title: '', des: '' }
        }];
        setDataDetail(newDataDetail);
    };

    // Function to remove the last object from dataDetail array
    const removeObjectFromArray = () => {
        const newDataDetail = dataDetail.slice(0, -1); // Remove the last element
        setDataDetail(newDataDetail);
    };

    async function urlToBlob(url) {
        // Fetch the image data from the URL
        const response = await fetch(url);
    
        // Convert the fetched image data to Blob
        const blob = await response.blob();
    
        return blob;
    }

    const fetchingData = async () => {
        try {
            await setLoading(true);
            const result = await getDataAboutUs()
            setEditId(result?.data?._id)
            setTxtEnCompany(result?.data?.company_profile_en)
            setTxtThCompany(result?.data?.company_profile_th)
            setTxtEnVisionMission(result?.data?.company_vission_en)
            setTxtThVisionMission(result?.data?.company_vission_th)
            setTxtEnBackground(result?.data?.company_background_en)
            setTxtThBackground(result?.data?.company_background_th)
            // ################## detail list #####################33
            const rawDetailList = result?.data?.detail_list?.map((item) => {
                return {
                    eng: { title: item?.title_en, des: item?.description_en },
                    tha: { title: item?.title_th, des: item?.description_th }
                }
            })
            setDataDetail(rawDetailList)

            setImagesFromApi1([{
                id: 0,
                status: false,
                src:
                    result?.data?.image_company_background === null ||
                    result?.data?.image_company_background === ""
                    ? ''
                    : result?.data?.image_company_background,
                file: result?.data?.image_company_background ? await urlToBlob(result?.data?.image_company_background) : null,
                size: 1024*1024*4, //hard code ให้ผ่าน validate 
                type:'image/jpg' //hard code ให้ผ่าน validate
            }])
            setImagesFromApi2([{
                id: 0,
                status: false,
                src:
                    result?.data?.image_vission === null ||
                    result?.data?.image_vission === ""
                    ? ''
                    : result?.data?.image_vission,
                file: result?.data?.image_vission ? await urlToBlob(result?.data?.image_vission) : null,
                size: 1024*1024*4, //hard code ให้ผ่าน validate 
                type:'image/jpg' //hard code ให้ผ่าน validate
            }])
            const path = result?.data?.privacy_file ?? ''
            let fileName = ''
            if(path)
            {
                const parts = result?.data?.privacy_file?.split('/')
                fileName = parts[parts.length - 1];
            }
            setImagesFromApi3([{
                id: 0,
                status: false,
                src:
                    result?.data?.privacy_file === null ||
                    result?.data?.privacy_file === ""
                    ? ''
                    : result?.data?.privacy_file,
                file: result?.data?.privacy_file ? await urlToBlob(result?.data?.privacy_file) : null,
                size: 1024*1024*4, //hard code ให้ผ่าน validate 
                type:'application/pdf', //hard code ให้ผ่าน validate
                name:fileName
            }])
        } catch (error) {
            console.log('found error', error)
        }
        await setLoading(false);
    }

    useEffect(() => {
        fetchingData()
    }, [])
    return (
        <>
            {isLoading ? <Loading /> : ""}
            <style>
                {`
                    .ck.ck-editor__main>.ck-editor__editable:not(.ck-focused) {
                        height: 200px;
                    }
                `}
            </style>
            <Header parentmenu={"ABOUT US"} />
            <Menu
                parentmenu={"infoAboutUs"}
                activemenu={"infoAboutUs"}
            />
            <div className="content-wrapper">
                <div className="container-fluid pdb-page">
                    <div className="box-white">
                        <Row>
                            <Col xs={12}>
                                <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                    <img src="assets/icons/ic-about.png" className="ic-user01 me-2" alt="" />
                                    ABOUT US
                                </font>
                            </Col>
                        </Row>
                        <div className='mx-5 mt-4'>
                            <Row>
                                <Col xs={12}>
                                    <font className="font-size01 colorBlack01 fontBold">
                                        COMPANY PROFILE <span className=' colorRed'>*</span>
                                    </font>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6}>
                                    <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        English
                                    </font>
                                </Col>
                                <Col xs={6}>
                                    <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        ภาษาไทย
                                    </font>
                                </Col>
                            </Row>
                            <Row className='mt-2'>
                                <Col xs={6}>
                                    <CustomCKEditor
                                        data={txtEnCompany}
                                        onChange={setTxtEnCompany}
                                        placeholder="Company Profile"
                                    />
                                </Col>
                                <Col xs={6}>
                                    <CustomCKEditor
                                        data={txtThCompany}
                                        onChange={setTxtThCompany}
                                        placeholder="ข้อมูลบริษัท"
                                    />
                                </Col>
                            </Row>
                            <Row className='mt-2'>
                                <Col xs={6}>
                                    <CustomCKEditor
                                        data={txtEnBackground}
                                        onChange={setTxtEnBackground}
                                        placeholder="Background"
                                    />
                                </Col>
                                <Col xs={6}>
                                    <CustomCKEditor
                                        data={txtThBackground}
                                        onChange={setTxtThBackground}
                                        placeholder="ข้อมูลเพิ่มเติม"
                                    />
                                </Col>
                            </Row>
                            <Row className='mt-2'>
                                <Col xs={6}>
                                    <CustomCKEditor
                                        data={txtEnVisionMission}
                                        onChange={setTxtEnVisionMission}
                                        placeholder="Vision and Mission"
                                    />
                                </Col>
                                <Col xs={6}>
                                    <CustomCKEditor
                                        data={txtThVisionMission}
                                        onChange={setTxtThVisionMission}
                                        placeholder="วิสัยทัศน์และพันธกิจ"
                                    />
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="box-white mt-4">
                        <Row>
                            <Col xs={6}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    image Background <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    image Vision and Mission <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-4'>
                            <Col xs={6}>
                                <UploadIMG
                                    limit={1}
                                    onSelectedImages={handleSelectedImages1}
                                    images={imagesFromApi1}
                                    txtDetail={"jpg. / 960x460 px , limit size 5MB"}
                                    removeImg={handleSelectedRemoveImg1}
                                />
                            </Col>
                            <Col xs={6}>
                                <UploadIMG
                                    limit={1}
                                    onSelectedImages={handleSelectedImages2}
                                    images={imagesFromApi2}
                                    txtDetail={"jpg. / 960x460 px , limit size 5MB"}
                                    removeImg={handleSelectedRemoveImg2}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className="box-white mt-4">
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    PRIVACY POLICY <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-4'>
                            <Col xs={6}>
                                <Row className='align-items-center'>
                                    <Col xs={1}><span className='fontReg font-size03 colorBlack01'>File</span></Col>
                                    <Col xs={11} className='pe-1'>
                                        <UploadFilePDF
                                            limit={1}
                                            onSelectedFile={handleSelectedImages3}
                                            selectFiles={imagesFromApi3}
                                            txtDetail={"pdf. / limit size 5MB"}
                                            removeImg={handleSelectedRemoveImg3}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    DETAIL <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <div className='mx-5 mt-4'>
                            <Row>
                                <Col xs={6}>
                                    <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        English
                                    </font>
                                </Col>
                                <Col xs={6}>
                                    <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        ภาษาไทย
                                    </font>
                                </Col>
                            </Row>
                            {dataDetail?.map((data, index) => (
                                <div key={index}>
                                    <Row>
                                        <Col xs={6}>
                                            <font className="font-size02 colorBlack01 fontBold">
                                                {`0${index + 1}`}
                                            </font>
                                        </Col>
                                        <Col xs={6}>
                                            <font className="font-size02 colorBlack01 fontBold">
                                                {`0${index + 1}`}
                                            </font>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={6}>
                                            <Text
                                                value={data.eng.title}
                                                onChange={(e) => handleChangeInpEnTitle(index, e.target.value)}
                                                placeholder="Title"
                                            />
                                        </Col>
                                        <Col xs={6}>
                                            <Text
                                                value={data.tha.title}
                                                onChange={(e) => handleChangeInpThTitle(index, e.target.value)}
                                                placeholder="ข้อเรื่อง"
                                            />
                                        </Col>
                                    </Row>
                                    <Row className='mt-2'>
                                        <Col xs={6}>
                                            <CustomCKEditor
                                                data={data.eng.des}
                                                onChange={(newValue) => updateDescription(index, "eng", newValue)}
                                                placeholder="Description"
                                            />
                                        </Col>
                                        <Col xs={6}>
                                            <CustomCKEditor
                                                data={data.tha.des}
                                                onChange={(newValue) => updateDescription(index, "tha", newValue)}
                                                placeholder="คำอธิบาย"
                                            />
                                        </Col>
                                    </Row>
                                </div>
                            ))}
                            <Row>
                                <Col xs={12} className='d-flex justify-content-end'>
                                    <div className='d-flex justify-content-between me-5'>
                                        <Button className='btn-none' onClick={addObjectToArray}>
                                            <img src="assets/icons/btn-add.png" className="sty-ic02 me-2" alt="" />
                                        </Button>
                                        <Button className='btn-none' onClick={removeObjectFromArray}>
                                            <img src="assets/icons/btn-delete.png" className="sty-ic02 me-2" alt="" />
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <Row className="ms-5 mt-4">
                        <Col xs={1} className="p-0 d-flex justify-content-start me-4">
                            <button
                                className="btn-cancle01"
                                onClick={() => handleClickCancel()}
                            >
                                CANCEL
                            </button>
                        </Col>
                        <Col xs={1} className="p-0 d-flex justify-content-start">
                            <button
                                className="btn-save01"
                                onClick={(e) => {
                                    handleSaveBtn();
                                }}
                            >
                                SAVE
                            </button>
                        </Col>
                    </Row>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default AboutUs;